// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35O6k","left":"styles_left__Nx3t5","desktopActions":"styles_desktopActions__2llIp","title":"styles_title__2tXUj"};